import React from 'react';
import PropTypes from 'prop-types';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useIntl } from 'react-intl';

import ImageEditor from './ImageEditor/Editor';

import { userCan } from '../helpers/Auth';
import { userHasFeature } from '../helpers/Features';

const ImageEditorModal = ({ handleClose, ...props }) => {
  const intl = useIntl();

  if (!userHasFeature('image-editor') || !userCan('file.use_image_editor')) {
    return null;
  }

  return (
    <>
      <ModalHeader toggle={handleClose}>
        {intl.formatMessage({ defaultMessage: 'Image Editor' })}
      </ModalHeader>
      <ModalBody>
        <ImageEditor {...props} />
      </ModalBody>
      <ModalFooter />
    </>
  );
};

ImageEditorModal.propTypes = {
  file: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ImageEditorModal;
